import script from "./AuditDiscoveryIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditDiscoveryIndex.vue?vue&type=script&setup=true&lang=js"

import "./AuditDiscoveryIndex.vue?vue&type=style&index=0&id=56a30676&lang=css"
import "./AuditDiscoveryIndex.vue?vue&type=style&index=1&id=56a30676&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a30676"]])

export default __exports__